import React, { Fragment } from "react";

import { groupPostsByLetter } from "../../helpers/groupByLetter";
import Disease from "./Disease";
import NoResults from "./NoResults";
import PropTypes from "prop-types";

const DiseaseList = (props) => {
  const { results } = props;

  if (!results) {
    return false;
  }

  // filter funds by open and/or closed status
  const checkStatus = (result) => {
    const fundStatus = (result.Fund_Status || "").toLowerCase();

    switch (fundStatus) {
      case "open":
        // FIXME-799
        // if (result.IsRenewalOnly) {
        //   return props.reEnrollment;
        // } else {
        //   return props.open;
        // }
        return props.open;
      case "closed, wait list available":
        return props.closed;
      case "closed":
        return props.closed;
      case "open to wait list only":
        return props.waitListOnly;
      default:
        return true;
    }
  };

  let filteredFunds = results.filter(checkStatus);

  filteredFunds = filteredFunds.filter((fund) => {
    if (!props.noLinks && (!fund.Fund_Name || !fund.permalink)) {
      return false;
    } else {
      return true;
    }
  });

  // Group funds by starting letter
  const groupedFunds = groupPostsByLetter(filteredFunds);

  // Filter funds by letter if a letter filter is selected
  let diseases = {};
  if (props.letter) {
    diseases[props.letter.toUpperCase()] =
      groupedFunds[props.letter.toUpperCase()];
  } else {
    diseases = groupedFunds;
  }

  // Sorts an array of fund objects by the Fund_Name property
  const sortFundsByName = (funds) => {
    return funds.sort(
      (a, b) =>
        (a.Fund_Name.toLowerCase() > b.Fund_Name.toLowerCase()) -
        (a.Fund_Name.toLowerCase() < b.Fund_Name.toLowerCase())
    );
  };

  const hasResults =
    !!Object.entries(diseases).length &&
    typeof Object.entries(diseases)[0][1] !== "undefined";

  return (
    <Fragment>
      {hasResults && (
        <ol className="Glossary-items">
          {Object.entries(diseases).map((entry, i) => (
            <li key={i} className="Glossary-item">
              <p className="f-h2 u-mb2">{entry[0]}</p>
              {sortFundsByName(entry[1]).map((result, i) => (
                <>
                  {result.Fund_Status !== "Inactive" && (
                    <Disease
                      key={i}
                      disease={result}
                      displayStatus={props.displayStatus}
                    />
                  )}
                </>
              ))}
            </li>
          ))}
        </ol>
      )}

      {!hasResults && (
        <NoResults message="Sorry, there are no disease funds associated with your search." />
      )}
    </Fragment>
  );
};

DiseaseList.propTypes = {
  letter: PropTypes.string,
  open: PropTypes.bool,
  closed: PropTypes.bool,
  waitListOnly: PropTypes.bool,
  displayStatus: PropTypes.bool,
  results: PropTypes.array,
};

export default DiseaseList;
